import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollWindowToTop, scrollWindowToTopWithRetry } from '@/utils/scroll';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return true;
        }
        return false;
      };
      if (tryScroll()) return;
      const timer = window.setTimeout(() => {
        if (!tryScroll()) {
          scrollWindowToTop();
        }
      }, 200);
      return () => window.clearTimeout(timer);
    }

    return scrollWindowToTopWithRetry([0, 100, 300, 500]);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
